module.exports = __webpack_public_path__ + "img/unhcrLogo.a7fae5da.png";